import React, { useState, useEffect } from 'react';
import { Paper, Typography, Box, Link, Grid, Card, CardContent, CardMedia } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import axios from 'axios';
import Loading from './Loading';
import Moment from "react-moment";


const FeaturedPost = () => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const defaultImage = 'https://www.mrapi.mruns.com/wp-content/uploads/2020/01/83798790_2842918695768253_5984271632523329536_o-480x162.jpg';

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axios.get('https://www.mrapi.mruns.com/wp-json/wp/v2/posts?per_page=1&_embed');
        const fetchedPost = response.data[0];
        const imageUrl = fetchedPost._embedded?.['wp:featuredmedia']?.[0]?.source_url || defaultImage;
        setPost({ ...fetchedPost, imageUrl });
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchPost();
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (!post) {
    return null;
  }

  return (
    <Card sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, my: 2 }}>
      <CardMedia
        component="img"
        sx={{ width: { xs: '100%', md: 500 }, height: { xs: 250, md: 'auto' } }}
        image={post.imageUrl}
        alt={post.title.rendered}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <CardContent>
          <Typography component="h2" variant="h4" sx={{ fontWeight: 'bold' }}>
            <div dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ my: 1 }}>
            <Moment format="MMMM Do, YYYY">{post.date}</Moment>
          </Typography>
          <Typography variant="body1" paragraph>
            <div dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
          </Typography>
          <Link component={RouterLink} to={`/detail/${post.slug}`} variant="subtitle1">
            Continue reading...
          </Link>
        </CardContent>
      </Box>
    </Card>
  );
};

export default FeaturedPost;
